// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Jotai from "jotai";
import * as Core__JSON from "@rescript/core/src/Core__JSON.bs.js";
import * as Stdlib_Exn from "@rescript/runtime/lib/es6/Stdlib_Exn.js";
import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";
import * as Core__Promise from "@rescript/core/src/Core__Promise.bs.js";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as RescriptReactRouter from "@rescript/react/src/RescriptReactRouter.bs.js";
import * as Utils$OrcaPaymentPage from "./Utils.bs.js";
import * as Window$OrcaPaymentPage from "../Window.bs.js";
import * as APIUtils$OrcaPaymentPage from "./APIHelpers/APIUtils.bs.js";
import * as CardUtils$OrcaPaymentPage from "../CardUtils.bs.js";
import * as Constants$OrcaPaymentPage from "./Constants.bs.js";
import * as JotaiAtoms$OrcaPaymentPage from "./JotaiAtoms.bs.js";
import * as ApiEndpoint$OrcaPaymentPage from "./ApiEndpoint.bs.js";
import * as BrowserSpec$OrcaPaymentPage from "../BrowserSpec.bs.js";
import * as LoggerUtils$OrcaPaymentPage from "./LoggerUtils.bs.js";
import * as PaymentBody$OrcaPaymentPage from "./PaymentBody.bs.js";
import * as PaymentType$OrcaPaymentPage from "../Types/PaymentType.bs.js";
import * as PaymentError$OrcaPaymentPage from "../Types/PaymentError.bs.js";
import * as CardThemeType$OrcaPaymentPage from "../Types/CardThemeType.bs.js";
import * as NextActionHelpers$OrcaPaymentPage from "./NextActionHelpers.bs.js";
import * as PaymentConfirmTypes$OrcaPaymentPage from "../Types/PaymentConfirmTypes.bs.js";
import * as PaymentMethodsRecord$OrcaPaymentPage from "../Payments/PaymentMethodsRecord.bs.js";

function getPaymentType(paymentMethodType) {
  switch (paymentMethodType) {
    case "apple_pay" :
      return "Applepay";
    case "" :
    case "credit" :
    case "debit" :
      return "Card";
    case "google_pay" :
      return "Gpay";
    case "paze" :
      return "Paze";
    case "samsung_pay" :
      return "Samsungpay";
    default:
      return "Other";
  }
}

async function retrievePaymentIntent(clientSecret, headers, publishableKey, logger, customPodUri, isForceSyncOpt, sdkAuthorizationOpt) {
  let isForceSync = isForceSyncOpt !== undefined ? isForceSyncOpt : false;
  let sdkAuthorization = sdkAuthorizationOpt !== undefined ? Primitive_option.valFromOption(sdkAuthorizationOpt) : undefined;
  let uri = APIUtils$OrcaPaymentPage.generateApiUrlV1({
    publishableKey: publishableKey,
    customBackendBaseUrl: undefined,
    clientSecret: clientSecret,
    forceSync: isForceSync ? "true" : undefined,
    pollId: undefined,
    payoutId: undefined,
    sdkAuthorization: sdkAuthorization
  }, "RetrievePaymentIntent");
  let onSuccess = data => data;
  let onFailure = param => null;
  let headers$1 = headers !== undefined ? headers : ({});
  return await Utils$OrcaPaymentPage.fetchApiWithLogging(uri, "RETRIEVE_CALL", logger, onSuccess, onFailure, undefined, headers$1, "GET", Primitive_option.some(customPodUri), Primitive_option.some(publishableKey), undefined, undefined, Primitive_option.some(sdkAuthorization), undefined);
}

async function fetchPaymentMethodEligibility(clientSecret, publishableKey, logger, customPodUri, bodyArr, sdkAuthorizationOpt, endpoint, signal) {
  let sdkAuthorization = sdkAuthorizationOpt !== undefined ? Primitive_option.valFromOption(sdkAuthorizationOpt) : undefined;
  let uri = APIUtils$OrcaPaymentPage.generateApiUrlV1({
    publishableKey: publishableKey,
    customBackendBaseUrl: endpoint,
    clientSecret: clientSecret,
    forceSync: undefined,
    pollId: undefined,
    payoutId: undefined,
    sdkAuthorization: sdkAuthorization
  }, "FetchPaymentMethodEligibility");
  let match = Utils$OrcaPaymentPage.getNonEmptyOption(sdkAuthorization);
  let body = match !== undefined ? Utils$OrcaPaymentPage.getJsonFromArrayOfJson(bodyArr) : Utils$OrcaPaymentPage.getJsonFromArrayOfJson(bodyArr.concat([[
        "client_secret",
        clientSecret
      ]]));
  let onSuccess = data => data;
  let onFailure = param => null;
  return await Utils$OrcaPaymentPage.fetchApiWithLogging(uri, "PAYMENT_METHOD_ELIGIBILITY_CALL", logger, onSuccess, onFailure, JSON.stringify(body), undefined, "POST", Primitive_option.some(customPodUri), Primitive_option.some(publishableKey), undefined, undefined, Primitive_option.some(sdkAuthorization), signal);
}

async function threeDsAuth(clientSecret, logger, threeDsMethodComp, headers, sdkAuthorizationOpt) {
  let sdkAuthorization = sdkAuthorizationOpt !== undefined ? Primitive_option.valFromOption(sdkAuthorizationOpt) : undefined;
  let url = APIUtils$OrcaPaymentPage.generateApiUrlV1({
    publishableKey: undefined,
    customBackendBaseUrl: undefined,
    clientSecret: clientSecret,
    forceSync: undefined,
    pollId: undefined,
    payoutId: undefined,
    sdkAuthorization: sdkAuthorization
  }, "FetchThreeDsAuth");
  let match = Utils$OrcaPaymentPage.getNonEmptyOption(sdkAuthorization);
  let clientSecretArr = match !== undefined ? [] : [[
        "client_secret",
        clientSecret
      ]];
  let body = Utils$OrcaPaymentPage.getJsonFromArrayOfJson([
    [
      "device_channel",
      "BRW"
    ],
    [
      "threeds_method_comp_ind",
      threeDsMethodComp
    ]
  ].concat(BrowserSpec$OrcaPaymentPage.broswerInfo(), clientSecretArr));
  let onSuccess = data => data;
  let onFailure = data => {
    let dict = Utils$OrcaPaymentPage.getDictFromJson(data);
    let errorObj = PaymentError$OrcaPaymentPage.itemToObjMapper(dict);
    Utils$OrcaPaymentPage.closePaymentLoaderIfAny();
    Utils$OrcaPaymentPage.postFailedSubmitResponse(errorObj.error.type_, errorObj.error.message);
    return null;
  };
  let onCatchCallback = err => {
    Utils$OrcaPaymentPage.closePaymentLoaderIfAny();
    return Stdlib_Exn.raiseError(JSON.stringify(err));
  };
  return await Utils$OrcaPaymentPage.fetchApiWithLogging(url, "AUTHENTICATION_CALL", logger, onSuccess, onFailure, JSON.stringify(body), headers, "POST", undefined, undefined, undefined, Primitive_option.some(onCatchCallback), Primitive_option.some(sdkAuthorization), undefined);
}

function pollRetrievePaymentIntent(clientSecret, headers, publishableKey, logger, customPodUri, isForceSyncOpt, sdkAuthorizationOpt) {
  let isForceSync = isForceSyncOpt !== undefined ? isForceSyncOpt : false;
  let sdkAuthorization = sdkAuthorizationOpt !== undefined ? Primitive_option.valFromOption(sdkAuthorizationOpt) : undefined;
  return Core__Promise.$$catch(retrievePaymentIntent(clientSecret, headers, publishableKey, logger, customPodUri, isForceSync, Primitive_option.some(sdkAuthorization)).then(json => {
    let dict = Utils$OrcaPaymentPage.getDictFromJson(json);
    let status = Utils$OrcaPaymentPage.getString(dict, "status", "");
    if (status === "succeeded" || status === "failed") {
      return Promise.resolve(json);
    } else {
      return Core__Promise.$$catch(Utils$OrcaPaymentPage.delay(2000).then(_val => pollRetrievePaymentIntent(clientSecret, headers, publishableKey, logger, customPodUri, isForceSync, Primitive_option.some(sdkAuthorization))), param => Promise.resolve(null));
    }
  }), e => {
    console.error("Unable to retrieve payment due to following error", e);
    return pollRetrievePaymentIntent(clientSecret, headers, publishableKey, logger, customPodUri, isForceSync, Primitive_option.some(sdkAuthorization));
  });
}

async function retrieveStatus(publishableKey, customPodUri, pollID, logger, sdkAuthorization) {
  let uri = APIUtils$OrcaPaymentPage.generateApiUrlV1({
    publishableKey: publishableKey,
    customBackendBaseUrl: undefined,
    clientSecret: undefined,
    forceSync: undefined,
    pollId: pollID,
    payoutId: undefined,
    sdkAuthorization: sdkAuthorization
  }, "RetrieveStatus");
  let onSuccess = data => data;
  let onFailure = param => null;
  return await Utils$OrcaPaymentPage.fetchApiWithLogging(uri, "POLL_STATUS_CALL", logger, onSuccess, onFailure, "", undefined, "GET", Primitive_option.some(customPodUri), Primitive_option.some(publishableKey), undefined, undefined, Primitive_option.some(sdkAuthorization), undefined);
}

function pollStatus(publishableKey, customPodUri, pollId, interval, count, returnUrl, logger, sdkAuthorization) {
  return Core__Promise.$$catch(retrieveStatus(publishableKey, customPodUri, pollId, logger, sdkAuthorization).then(json => {
    let dict = Utils$OrcaPaymentPage.getDictFromJson(json);
    let status = Utils$OrcaPaymentPage.getString(dict, "status", "");
    return new Promise((resolve, param) => {
      if (status === "completed") {
        return resolve(json);
      } else if (count === 0) {
        Utils$OrcaPaymentPage.messageParentWindow(undefined, [[
            "fullscreen",
            false
          ]]);
        return Utils$OrcaPaymentPage.openUrl(returnUrl);
      } else {
        Core__Promise.$$catch(Utils$OrcaPaymentPage.delay(interval).then(param => pollStatus(publishableKey, customPodUri, pollId, interval, count - 1 | 0, returnUrl, logger, sdkAuthorization).then(res => {
          resolve(res);
          return Promise.resolve();
        })), param => Promise.resolve());
        return;
      }
    });
  }), e => {
    console.error("Unable to retrieve payment due to following error", e);
    return pollStatus(publishableKey, customPodUri, pollId, interval, count - 1 | 0, returnUrl, logger, sdkAuthorization).then(res => Promise.resolve(res));
  });
}

function intentCall(fetchApi, uri, headers, bodyStr, confirmParam, clientSecret, optLogger, handleUserError, paymentType, iframeId, fetchMethod, setIsManualRetryEnabled, customPodUri, sdkHandleOneClickConfirmPayment, counter, isPaymentSessionOpt, isCallbackUsedVal, componentNameOpt, redirectionFlags, sdkAuthorizationOpt, modeOpt, isTrustpayInterceptorConfirmOpt) {
  let isPaymentSession = isPaymentSessionOpt !== undefined ? isPaymentSessionOpt : false;
  let componentName = componentNameOpt !== undefined ? componentNameOpt : "payment";
  let sdkAuthorization = sdkAuthorizationOpt !== undefined ? Primitive_option.valFromOption(sdkAuthorizationOpt) : undefined;
  let mode = modeOpt !== undefined ? modeOpt : "NONE";
  let isTrustpayInterceptorConfirm = isTrustpayInterceptorConfirmOpt !== undefined ? isTrustpayInterceptorConfirmOpt : false;
  let isConfirm = uri.includes("/confirm");
  let isLegacyClientSecretFlow = Core__Option.isNone(Utils$OrcaPaymentPage.getNonEmptyOption(sdkAuthorization));
  let isCompleteAuthorize = uri.includes("/complete_authorize");
  let isPostSessionTokens = uri.includes("/post_session_tokens");
  let match = isConfirm ? [
      "CONFIRM_CALL",
      "CONFIRM_CALL_INIT"
    ] : (
      isCompleteAuthorize ? [
          "COMPLETE_AUTHORIZE_CALL",
          "COMPLETE_AUTHORIZE_CALL_INIT"
        ] : (
          isPostSessionTokens ? [
              "POST_SESSION_TOKENS_CALL",
              "POST_SESSION_TOKENS_CALL_INIT"
            ] : [
              "RETRIEVE_CALL",
              "RETRIEVE_CALL_INIT"
            ]
        )
    );
  let eventName = match[0];
  LoggerUtils$OrcaPaymentPage.logApi(match[1], undefined, undefined, "Request", uri, undefined, undefined, optLogger, "INFO", "API", isPaymentSession);
  let handleOpenUrl = url => {
    if (isPaymentSession && mode !== "CardCVCElement") {
      return Utils$OrcaPaymentPage.replaceRootHref(url, redirectionFlags);
    } else {
      return Utils$OrcaPaymentPage.openUrl(url);
    }
  };
  return Core__Promise.$$catch(fetchApi(uri, bodyStr, ApiEndpoint$OrcaPaymentPage.addCustomPodHeader(headers, customPodUri), fetchMethod, undefined, undefined, Primitive_option.some(sdkAuthorization), undefined).then(res => {
    let statusCode = res.status;
    let url = new URL(confirmParam.return_url);
    if (isLegacyClientSecretFlow) {
      url.searchParams.set("payment_intent_client_secret", clientSecret);
    }
    url.searchParams.set("status", "failed");
    url.searchParams.set("payment_id", Utils$OrcaPaymentPage.getPaymentIdOrExtractFromSdkAuth(clientSecret, sdkAuthorization));
    Utils$OrcaPaymentPage.messageParentWindow(undefined, [[
        "confirmParams",
        confirmParam
      ]]);
    if (res.ok) {
      return res.json().then(data => new Promise((resolve, param) => {
        LoggerUtils$OrcaPaymentPage.logApi(eventName, statusCode, undefined, "Response", uri, undefined, undefined, optLogger, undefined, undefined, isPaymentSession);
        let intent = PaymentConfirmTypes$OrcaPaymentPage.itemToObjMapper(Utils$OrcaPaymentPage.getDictFromJson(data));
        let paymentMethod;
        paymentMethod = paymentType === "Card" ? "CARD" : intent.payment_method_type;
        let url = new URL(confirmParam.return_url);
        if (isLegacyClientSecretFlow) {
          url.searchParams.set("payment_intent_client_secret", clientSecret);
        }
        url.searchParams.set("payment_id", Utils$OrcaPaymentPage.getPaymentIdOrExtractFromSdkAuth(clientSecret, sdkAuthorization));
        url.searchParams.set("status", intent.status);
        let handleProcessingStatus = (paymentType, sdkHandleOneClickConfirmPayment) => {
          let exit = 0;
          switch (paymentType) {
            case "Card" :
              exit = 2;
              break;
            case "Gpay" :
            case "Applepay" :
            case "Paypal" :
              exit = sdkHandleOneClickConfirmPayment ? 1 : 2;
              break;
            default:
              exit = 1;
          }
          switch (exit) {
            case 1 :
              if (mode === "CardCVCElement") {
                return resolve(Utils$OrcaPaymentPage.getJsonFromArrayOfJson([
                  [
                    "data",
                    data
                  ],
                  [
                    "returnUrl",
                    url.href
                  ]
                ]));
              } else if (Core__Option.getOr(isCallbackUsedVal, false)) {
                Utils$OrcaPaymentPage.closePaymentLoaderIfAny();
                return Utils$OrcaPaymentPage.handleOnCompleteDoThisMessage(undefined);
              } else {
                return handleOpenUrl(url.href);
              }
            case 2 :
              if (isPaymentSession) {
                if (confirmParam.redirect === "always") {
                  if (Core__Option.getOr(isCallbackUsedVal, false)) {
                    return Utils$OrcaPaymentPage.handleOnCompleteDoThisMessage(undefined);
                  } else {
                    return handleOpenUrl(url.href);
                  }
                } else {
                  return resolve(data);
                }
              } else {
                if (Core__Option.getOr(isCallbackUsedVal, false)) {
                  Utils$OrcaPaymentPage.handleOnCompleteDoThisMessage(undefined);
                } else {
                  Utils$OrcaPaymentPage.closePaymentLoaderIfAny();
                }
                return Utils$OrcaPaymentPage.postSubmitResponse(data, url.href);
              }
          }
        };
        if (intent.status === "requires_customer_action") {
          if (intent.nextAction.type_ === "redirect_to_url") {
            LoggerUtils$OrcaPaymentPage.handleLogging(optLogger, "", "REDIRECTING_USER", paymentMethod, undefined);
            return handleOpenUrl(intent.nextAction.redirectToUrl);
          }
          if (intent.nextAction.type_ === "redirect_inside_popup") {
            let popupUrl = intent.nextAction.popupUrl;
            let redirectResponseUrl = intent.nextAction.redirectResponseUrl;
            LoggerUtils$OrcaPaymentPage.handleLogging(optLogger, "", "THREE_DS_POPUP_REDIRECTION", paymentMethod, undefined);
            let metaData = [
              [
                "popupUrl",
                popupUrl
              ],
              [
                "redirectResponseUrl",
                redirectResponseUrl
              ]
            ];
            return Utils$OrcaPaymentPage.messageParentWindow(undefined, [
              [
                "fullscreen",
                true
              ],
              [
                "param",
                `3dsRedirectionPopup`
              ],
              [
                "iframeId",
                iframeId
              ],
              [
                "metadata",
                Utils$OrcaPaymentPage.getJsonFromArrayOfJson(metaData)
              ]
            ]);
          }
          if (intent.nextAction.type_ === "display_bank_transfer_information") {
            let obj = intent.nextAction.bank_transfer_steps_and_charges_details;
            let metadata = obj !== undefined ? Utils$OrcaPaymentPage.getDictFromJson(obj) : ({});
            let dict = Utils$OrcaPaymentPage.deepCopyDict(metadata);
            dict["data"] = data;
            dict["url"] = url.href;
            LoggerUtils$OrcaPaymentPage.handleLogging(optLogger, "", "DISPLAY_BANK_TRANSFER_INFO_PAGE", paymentMethod, undefined);
            if (!isPaymentSession) {
              Utils$OrcaPaymentPage.messageParentWindow(undefined, [
                [
                  "fullscreen",
                  true
                ],
                [
                  "param",
                  intent.payment_method_type + `BankTransfer`
                ],
                [
                  "iframeId",
                  iframeId
                ],
                [
                  "metadata",
                  dict
                ]
              ]);
            }
            return resolve(data);
          }
          if (intent.nextAction.type_ === "qr_code_information") {
            let qrData = Core__Option.getOr(intent.nextAction.image_data_url, "");
            let rawQrData = Core__Option.getOr(intent.nextAction.raw_qr_data, "");
            let displayText = Core__Option.getOr(intent.nextAction.display_text, "");
            let borderColor = Core__Option.getOr(intent.nextAction.border_color, "");
            let expiryTime = Core__Option.getOr(intent.nextAction.display_to_timestamp, 0.0);
            let headerObj = {};
            Utils$OrcaPaymentPage.mergeHeadersIntoDict(headerObj, headers);
            let metaData$1 = Utils$OrcaPaymentPage.getJsonFromArrayOfJson([
              [
                "qrData",
                qrData
              ],
              [
                "rawQrData",
                rawQrData
              ],
              [
                "paymentIntentId",
                clientSecret
              ],
              [
                "sdkAuthorization",
                Core__Option.getOr(sdkAuthorization, "")
              ],
              [
                "publishableKey",
                confirmParam.publishableKey
              ],
              [
                "headers",
                headerObj
              ],
              [
                "expiryTime",
                expiryTime.toString()
              ],
              [
                "url",
                url.href
              ],
              [
                "paymentMethod",
                paymentMethod
              ],
              [
                "display_text",
                displayText
              ],
              [
                "border_color",
                borderColor
              ]
            ]);
            LoggerUtils$OrcaPaymentPage.handleLogging(optLogger, "", "DISPLAY_QR_CODE_INFO_PAGE", paymentMethod, undefined);
            if (!isPaymentSession) {
              Utils$OrcaPaymentPage.messageParentWindow(undefined, [
                [
                  "fullscreen",
                  true
                ],
                [
                  "param",
                  `qrData`
                ],
                [
                  "iframeId",
                  iframeId
                ],
                [
                  "metadata",
                  metaData$1
                ]
              ]);
            }
            return resolve(data);
          }
          if (intent.nextAction.type_ === "three_ds_invoke") {
            let threeDsData = Core__Option.getOr(Core__Option.flatMap(intent.nextAction.three_ds_data, Core__JSON.Decode.object), {});
            let do3dsMethodCall = Utils$OrcaPaymentPage.getBoolValue(Core__JSON.Decode.bool(Core__Option.getOr(Core__Option.flatMap(Core__Option.flatMap(threeDsData["three_ds_method_details"], Core__JSON.Decode.object), x => x["three_ds_method_data_submission"]), {})));
            let headerObj$1 = {};
            Utils$OrcaPaymentPage.mergeHeadersIntoDict(headerObj$1, headers);
            let metaData$2 = Object.fromEntries([
              [
                "threeDSData",
                threeDsData
              ],
              [
                "paymentIntentId",
                clientSecret
              ],
              [
                "publishableKey",
                confirmParam.publishableKey
              ],
              [
                "sdkAuthorization",
                Core__Option.getOr(sdkAuthorization, "")
              ],
              [
                "headers",
                headerObj$1
              ],
              [
                "url",
                url.href
              ],
              [
                "iframeId",
                iframeId
              ]
            ]);
            LoggerUtils$OrcaPaymentPage.handleLogging(optLogger, do3dsMethodCall ? "Y" : "N", "THREE_DS_METHOD", paymentMethod, undefined);
            if (do3dsMethodCall) {
              return Utils$OrcaPaymentPage.messageParentWindow(undefined, [
                [
                  "fullscreen",
                  true
                ],
                [
                  "param",
                  `3ds`
                ],
                [
                  "iframeId",
                  iframeId
                ],
                [
                  "metadata",
                  metaData$2
                ]
              ]);
            } else {
              metaData$2["3dsMethodComp"] = "U";
              return Utils$OrcaPaymentPage.messageParentWindow(undefined, [
                [
                  "fullscreen",
                  true
                ],
                [
                  "param",
                  `3dsAuth`
                ],
                [
                  "iframeId",
                  iframeId
                ],
                [
                  "metadata",
                  metaData$2
                ]
              ]);
            }
          }
          if (intent.nextAction.type_ === "invoke_hidden_iframe") {
            let iframeData = Core__Option.getOr(Core__Option.flatMap(intent.nextAction.iframe_data, Core__JSON.Decode.object), {});
            let headerObj$2 = {};
            Utils$OrcaPaymentPage.mergeHeadersIntoDict(headerObj$2, headers);
            let metaData$3 = Object.fromEntries([
              [
                "iframeData",
                iframeData
              ],
              [
                "clientSecret",
                clientSecret
              ],
              [
                "publishableKey",
                confirmParam.publishableKey
              ],
              [
                "sdkAuthorization",
                Core__Option.getOr(sdkAuthorization, "")
              ],
              [
                "headers",
                headerObj$2
              ],
              [
                "url",
                url.href
              ],
              [
                "iframeId",
                iframeId
              ],
              [
                "confirmParams",
                confirmParam
              ]
            ]);
            return Utils$OrcaPaymentPage.messageParentWindow(undefined, [
              [
                "fullscreen",
                true
              ],
              [
                "param",
                `redsys3ds`
              ],
              [
                "iframeId",
                iframeId
              ],
              [
                "metadata",
                metaData$3
              ]
            ]);
          }
          if (intent.nextAction.type_ === "invoke_ddc") {
            return NextActionHelpers$OrcaPaymentPage.handleDDC(intent.nextAction.ddc_data, iframeId, isPaymentSession, resolve, data, optLogger, paymentMethod);
          }
          if (intent.nextAction.type_ === "display_voucher_information") {
            let voucherData = Core__Option.getOr(intent.nextAction.voucher_details, {
              download_url: "",
              reference: ""
            });
            let headerObj$3 = {};
            Utils$OrcaPaymentPage.mergeHeadersIntoDict(headerObj$3, headers);
            let metaData$4 = Object.fromEntries([
              [
                "voucherUrl",
                voucherData.download_url
              ],
              [
                "reference",
                voucherData.reference
              ],
              [
                "returnUrl",
                url.href
              ],
              [
                "paymentMethod",
                paymentMethod
              ],
              [
                "payment_intent_data",
                data
              ]
            ]);
            LoggerUtils$OrcaPaymentPage.handleLogging(optLogger, "", "DISPLAY_VOUCHER", paymentMethod, undefined);
            return Utils$OrcaPaymentPage.messageParentWindow(undefined, [
              [
                "fullscreen",
                true
              ],
              [
                "param",
                `voucherData`
              ],
              [
                "iframeId",
                iframeId
              ],
              [
                "metadata",
                metaData$4
              ]
            ]);
          }
          if (intent.nextAction.type_ === "third_party_sdk_session_token") {
            let token = intent.nextAction.session_token;
            let session_token = token !== undefined ? Utils$OrcaPaymentPage.getDictFromJson(token) : ({});
            let walletName = Utils$OrcaPaymentPage.getString(session_token, "wallet_name", "");
            let message;
            switch (walletName) {
              case "apple_pay" :
                if (isTrustpayInterceptorConfirm) {
                  let secrets = Core__Option.getOr(Utils$OrcaPaymentPage.getDictFromDict(session_token, "session_token_data")["secrets"], null);
                  message = [[
                      "applePayConfirmSecrets",
                      secrets
                    ]];
                } else {
                  message = [
                    [
                      "applePayButtonClicked",
                      true
                    ],
                    [
                      "applePayPresent",
                      session_token
                    ],
                    [
                      "componentName",
                      componentName
                    ]
                  ];
                }
                break;
              case "google_pay" :
                message = [[
                    "googlePayThirdPartyFlow",
                    session_token
                  ]];
                break;
              case "open_banking" :
                let metaData$5 = Utils$OrcaPaymentPage.getJsonFromArrayOfJson([
                  [
                    "linkToken",
                    Utils$OrcaPaymentPage.getString(session_token, "open_banking_session_token", "")
                  ],
                  [
                    "pmAuthConnectorArray",
                    ["plaid"]
                  ],
                  [
                    "publishableKey",
                    confirmParam.publishableKey
                  ],
                  [
                    "clientSecret",
                    clientSecret
                  ],
                  [
                    "sdkAuthorization",
                    Core__Option.getOr(sdkAuthorization, "")
                  ],
                  [
                    "isForceSync",
                    true
                  ]
                ]);
                message = [
                  [
                    "fullscreen",
                    true
                  ],
                  [
                    "param",
                    "plaidSDK"
                  ],
                  [
                    "iframeId",
                    iframeId
                  ],
                  [
                    "metadata",
                    metaData$5
                  ]
                ];
                break;
              default:
                message = [];
            }
            if (!isPaymentSession) {
              Utils$OrcaPaymentPage.messageParentWindow(undefined, message);
            }
            return resolve(data);
          }
          if (intent.nextAction.type_ === "invoke_sdk_client") {
            let nextActionData = Core__Option.getOr(intent.nextAction.next_action_data, null);
            return resolve(Utils$OrcaPaymentPage.getJsonFromArrayOfJson([
              [
                "orderId",
                intent.connectorTransactionId
              ],
              [
                "nextActionData",
                nextActionData
              ]
            ]));
          }
          if (!isPaymentSession) {
            Utils$OrcaPaymentPage.postFailedSubmitResponse("confirm_payment_failed", "Payment failed. Try again!");
          }
          if (uri.includes("force_sync=true")) {
            LoggerUtils$OrcaPaymentPage.handleLogging(optLogger, intent.nextAction.type_, "REDIRECTING_USER", paymentMethod, "ERROR");
            return handleOpenUrl(url.href);
          } else {
            return resolve(Utils$OrcaPaymentPage.getFailedSubmitResponse("confirm_payment_failed", "Payment failed. Try again!"));
          }
        }
        if (intent.status === "requires_payment_method") {
          if (intent.nextAction.type_ !== "invoke_sdk_client") {
            return;
          }
          let nextActionData$1 = Core__Option.getOr(intent.nextAction.next_action_data, null);
          return resolve(Utils$OrcaPaymentPage.getJsonFromArrayOfJson([
            [
              "orderId",
              intent.connectorTransactionId
            ],
            [
              "nextActionData",
              nextActionData$1
            ]
          ]));
        }
        if (intent.status !== "processing") {
          if (intent.status !== "") {
            if (intent.status === "succeeded") {
              LoggerUtils$OrcaPaymentPage.handleLogging(optLogger, intent.status, "PAYMENT_SUCCESS", paymentMethod, undefined);
            } else if (intent.status === "failed") {
              LoggerUtils$OrcaPaymentPage.handleLogging(optLogger, intent.status, "PAYMENT_FAILED", paymentMethod, undefined);
            }
            if (intent.status === "failed") {
              setIsManualRetryEnabled(param => intent.manualRetryAllowed);
            }
            return handleProcessingStatus(paymentType, sdkHandleOneClickConfirmPayment);
          } else if (isPaymentSession) {
            return resolve(Utils$OrcaPaymentPage.getFailedSubmitResponse("confirm_payment_failed", "Payment failed. Try again!"));
          } else {
            return Utils$OrcaPaymentPage.postFailedSubmitResponse("confirm_payment_failed", "Payment failed. Try again!");
          }
        }
        if (intent.nextAction.type_ === "third_party_sdk_session_token") {
          let token$1 = intent.nextAction.session_token;
          let session_token$1 = token$1 !== undefined ? Utils$OrcaPaymentPage.getDictFromJson(token$1) : ({});
          let walletName$1 = Utils$OrcaPaymentPage.getString(session_token$1, "wallet_name", "");
          let message$1;
          switch (walletName$1) {
            case "apple_pay" :
              if (isTrustpayInterceptorConfirm) {
                let secrets$1 = Core__Option.getOr(Utils$OrcaPaymentPage.getDictFromDict(session_token$1, "session_token_data")["secrets"], null);
                message$1 = [[
                    "applePayConfirmSecrets",
                    secrets$1
                  ]];
              } else {
                message$1 = [
                  [
                    "applePayButtonClicked",
                    true
                  ],
                  [
                    "applePayPresent",
                    session_token$1
                  ]
                ];
              }
              break;
            case "google_pay" :
              message$1 = [[
                  "googlePayThirdPartyFlow",
                  session_token$1
                ]];
              break;
            default:
              message$1 = [];
          }
          if (!isPaymentSession) {
            Utils$OrcaPaymentPage.messageParentWindow(undefined, message$1);
          }
        } else {
          handleProcessingStatus(paymentType, sdkHandleOneClickConfirmPayment);
        }
        resolve(data);
      }).then(prim => Promise.resolve(prim)));
    } else {
      return Core__Promise.$$catch(res.json().then(data => new Promise((resolve, param) => {
        if (isConfirm) {
          let paymentMethod;
          paymentMethod = paymentType === "Card" ? "CARD" : Utils$OrcaPaymentPage.getString(Utils$OrcaPaymentPage.getDictFromJson(Utils$OrcaPaymentPage.safeParse(bodyStr)), "payment_method_type", "");
          LoggerUtils$OrcaPaymentPage.handleLogging(optLogger, JSON.stringify(data), "PAYMENT_FAILED", paymentMethod, undefined);
        }
        LoggerUtils$OrcaPaymentPage.logApi(eventName, statusCode, data, "Err", uri, undefined, undefined, optLogger, "ERROR", "API", isPaymentSession);
        let dict = Utils$OrcaPaymentPage.getDictFromJson(data);
        let errorObj = PaymentError$OrcaPaymentPage.itemToObjMapper(dict);
        if (!isPaymentSession) {
          Utils$OrcaPaymentPage.closePaymentLoaderIfAny();
          Utils$OrcaPaymentPage.postFailedSubmitResponse(errorObj.error.type_, errorObj.error.message);
        }
        if (handleUserError) {
          return handleOpenUrl(url.href);
        } else {
          return resolve(Utils$OrcaPaymentPage.getFailedSubmitResponse(errorObj.error.type_, errorObj.error.message));
        }
      }).then(prim => Promise.resolve(prim))), err => new Promise((resolve, param) => {
        let exceptionMessage = Utils$OrcaPaymentPage.formatException(err);
        LoggerUtils$OrcaPaymentPage.logApi(eventName, statusCode, exceptionMessage, "NoResponse", uri, undefined, undefined, optLogger, "ERROR", "API", isPaymentSession);
        if (counter >= 5) {
          if (!isPaymentSession) {
            Utils$OrcaPaymentPage.closePaymentLoaderIfAny();
            Utils$OrcaPaymentPage.postFailedSubmitResponse("server_error", "Something went wrong");
          }
          if (handleUserError) {
            return handleOpenUrl(url.href);
          } else {
            return resolve(Utils$OrcaPaymentPage.getFailedSubmitResponse("server_error", "Something went wrong"));
          }
        }
        let paymentIntentId = Utils$OrcaPaymentPage.getPaymentIdOrExtractFromSdkAuth(clientSecret, sdkAuthorization);
        let endpoint = ApiEndpoint$OrcaPaymentPage.getApiEndPoint(confirmParam.publishableKey, isConfirm);
        let clientSecretParam = isLegacyClientSecretFlow ? `?client_secret=` + clientSecret : "";
        let retrieveUri = endpoint + `/payments/` + paymentIntentId + clientSecretParam;
        Core__Promise.$$catch(intentCall(fetchApi, retrieveUri, headers, bodyStr, confirmParam, clientSecret, optLogger, handleUserError, paymentType, iframeId, "GET", setIsManualRetryEnabled, customPodUri, sdkHandleOneClickConfirmPayment, counter + 1 | 0, undefined, undefined, componentName, redirectionFlags, Primitive_option.some(sdkAuthorization), undefined, undefined).then(res => {
          resolve(res);
          return Promise.resolve();
        }), param => Promise.resolve());
      }).then(prim => Promise.resolve(prim)));
    }
  }), err => new Promise((resolve, param) => {
    try {
      let url = new URL(confirmParam.return_url);
      if (isLegacyClientSecretFlow) {
        url.searchParams.set("payment_intent_client_secret", clientSecret);
      }
      url.searchParams.set("payment_id", Utils$OrcaPaymentPage.getPaymentIdOrExtractFromSdkAuth(clientSecret, sdkAuthorization));
      url.searchParams.set("status", "failed");
      let exceptionMessage = Utils$OrcaPaymentPage.formatException(err);
      LoggerUtils$OrcaPaymentPage.logApi(eventName, undefined, exceptionMessage, "NoResponse", uri, undefined, undefined, optLogger, "ERROR", "API", isPaymentSession);
      if (counter >= 5) {
        if (!isPaymentSession) {
          Utils$OrcaPaymentPage.closePaymentLoaderIfAny();
          Utils$OrcaPaymentPage.postFailedSubmitResponse("server_error", "Something went wrong");
        }
        if (handleUserError) {
          return handleOpenUrl(url.href);
        } else {
          return resolve(Utils$OrcaPaymentPage.getFailedSubmitResponse("server_error", "Something went wrong"));
        }
      }
      let paymentIntentId = Utils$OrcaPaymentPage.getPaymentIdOrExtractFromSdkAuth(clientSecret, sdkAuthorization);
      let endpoint = ApiEndpoint$OrcaPaymentPage.getApiEndPoint(confirmParam.publishableKey, isConfirm);
      let clientSecretParam = isLegacyClientSecretFlow ? `?client_secret=` + clientSecret : "";
      let retrieveUri = endpoint + `/payments/` + paymentIntentId + clientSecretParam;
      Core__Promise.$$catch(intentCall(fetchApi, retrieveUri, headers, bodyStr, confirmParam, clientSecret, optLogger, handleUserError, paymentType, iframeId, "GET", setIsManualRetryEnabled, customPodUri, sdkHandleOneClickConfirmPayment, counter + 1 | 0, isPaymentSession, undefined, componentName, redirectionFlags, Primitive_option.some(sdkAuthorization), undefined, undefined).then(res => {
        resolve(res);
        return Promise.resolve();
      }), param => Promise.resolve());
      return;
    } catch (exn) {
      if (!isPaymentSession) {
        Utils$OrcaPaymentPage.postFailedSubmitResponse("error", "Something went wrong");
      }
      return resolve(Utils$OrcaPaymentPage.getFailedSubmitResponse("server_error", "Something went wrong"));
    }
  }).then(prim => Promise.resolve(prim)));
}

function usePaymentSync(optLogger, paymentType) {
  let paymentMethodList = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.paymentMethodList);
  let keys = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.keys);
  let isCallbackUsedVal = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.isCompleteCallbackUsed);
  let customPodUri = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.customPodUri);
  let redirectionFlags = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.redirectionFlagsAtom);
  let setIsManualRetryEnabled = Jotai.useSetAtom(JotaiAtoms$OrcaPaymentPage.isManualRetryEnabled);
  return (handleUserErrorOpt, confirmParam, iframeIdOpt) => {
    let handleUserError = handleUserErrorOpt !== undefined ? handleUserErrorOpt : false;
    let iframeId = iframeIdOpt !== undefined ? iframeIdOpt : "";
    let clientSecret = keys.clientSecret;
    if (clientSecret === undefined) {
      return Utils$OrcaPaymentPage.postFailedSubmitResponse("sync_payment_failed", "Sync Payment Failed. Try Again!");
    }
    let paymentIntentId = Utils$OrcaPaymentPage.getPaymentIdOrExtractFromSdkAuth(clientSecret, Utils$OrcaPaymentPage.getNonEmptyOption(keys.sdkAuthorization));
    let headers = [[
        "Content-Type",
        "application/json"
      ]];
    let match = Utils$OrcaPaymentPage.getNonEmptyOption(keys.sdkAuthorization);
    if (match !== undefined) {
      
    } else {
      headers.push([
        "api-key",
        confirmParam.publishableKey
      ]);
    }
    let endpoint = ApiEndpoint$OrcaPaymentPage.getApiEndPoint(confirmParam.publishableKey, undefined);
    let match$1 = Utils$OrcaPaymentPage.getNonEmptyOption(keys.sdkAuthorization);
    let clientSecretUriStr = match$1 !== undefined ? "" : `&client_secret=` + clientSecret;
    let uri = endpoint + `/payments/` + paymentIntentId + `?force_sync=true` + clientSecretUriStr;
    let paymentSync = () => {
      intentCall(Utils$OrcaPaymentPage.fetchApi, uri, headers, "", confirmParam, clientSecret, optLogger, handleUserError, paymentType, iframeId, "GET", setIsManualRetryEnabled, customPodUri, keys.sdkHandleOneClickConfirmPayment, 0, undefined, isCallbackUsedVal, undefined, redirectionFlags, Primitive_option.some(keys.sdkAuthorization), undefined, undefined);
    };
    if (typeof paymentMethodList !== "object" || paymentMethodList.TAG !== "Loaded") {
      return;
    } else {
      return paymentSync();
    }
  };
}

function maskStr(str) {
  return str.replace(/\S/g, "x");
}

function maskPayload(payloadJson) {
  let valueDict = Core__JSON.Classify.classify(payloadJson);
  if (typeof valueDict !== "object") {
    return "null";
  }
  switch (valueDict.TAG) {
    case "Bool" :
      return Utils$OrcaPaymentPage.getStringFromBool(valueDict._0);
    case "String" :
      return maskStr(valueDict._0);
    case "Number" :
      return maskStr(valueDict._0.toString());
    case "Object" :
      return Utils$OrcaPaymentPage.getJsonFromArrayOfJson(Object.entries(valueDict._0).map(entry => [
        entry[0],
        maskPayload(entry[1])
      ]));
    case "Array" :
      return valueDict._0.map(maskPayload);
  }
}

function useCompleteAuthorizeHandler() {
  let customPodUri = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.customPodUri);
  let setIsManualRetryEnabled = Jotai.useSetAtom(JotaiAtoms$OrcaPaymentPage.isManualRetryEnabled);
  let isCallbackUsedVal = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.isCompleteCallbackUsed);
  let redirectionFlags = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.redirectionFlagsAtom);
  let keys = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.keys);
  return (clientSecret, bodyArr, confirmParam, iframeId, optLogger, handleUserError, paymentType, sdkHandleOneClickConfirmPayment, headers, paymentMode, sdkAuthorization) => {
    if (clientSecret === undefined) {
      return Utils$OrcaPaymentPage.postFailedSubmitResponse("complete_authorize_failed", "Complete Authorize Failed. Try Again!");
    }
    let endpoint = ApiEndpoint$OrcaPaymentPage.getApiEndPoint(confirmParam.publishableKey, undefined);
    let paymentIntentId = Utils$OrcaPaymentPage.getPaymentIdOrExtractFromSdkAuth(clientSecret, sdkAuthorization);
    let uri = endpoint + `/payments/` + paymentIntentId + `/complete_authorize`;
    let finalHeaders = headers !== undefined ? headers : [
        [
          "Content-Type",
          "application/json"
        ],
        [
          "X-Client-Source",
          Core__Option.getOr(paymentMode, "")
        ]
      ];
    let match = Utils$OrcaPaymentPage.getNonEmptyOption(keys.sdkAuthorization);
    let match$1 = Utils$OrcaPaymentPage.getNonEmptyOption(sdkAuthorization);
    let sdkAuth = match !== undefined ? match : (
        match$1 !== undefined ? match$1 : undefined
      );
    if (sdkAuth !== undefined) {
      finalHeaders.push([
        "Authorization",
        sdkAuth
      ]);
    } else {
      finalHeaders.push([
        "api-key",
        confirmParam.publishableKey
      ]);
    }
    let clientSecretArr = sdkAuth !== undefined ? [] : [[
          "client_secret",
          clientSecret
        ]];
    let bodyStr = JSON.stringify(Utils$OrcaPaymentPage.getJsonFromArrayOfJson(clientSecretArr.concat(bodyArr, BrowserSpec$OrcaPaymentPage.broswerInfo())));
    intentCall(Utils$OrcaPaymentPage.fetchApi, uri, finalHeaders, bodyStr, confirmParam, clientSecret, optLogger, handleUserError, paymentType, iframeId, "POST", setIsManualRetryEnabled, customPodUri, sdkHandleOneClickConfirmPayment, 0, undefined, isCallbackUsedVal, undefined, redirectionFlags, Primitive_option.some(sdkAuth), undefined, undefined);
  };
}

function useCompleteAuthorize(optLogger, paymentType) {
  let completeAuthorizeHandler = useCompleteAuthorizeHandler();
  let keys = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.keys);
  let paymentMethodList = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.paymentMethodList);
  let url = RescriptReactRouter.useUrl(undefined, undefined);
  let mode = CardThemeType$OrcaPaymentPage.getPaymentModeToStrMapper(CardThemeType$OrcaPaymentPage.getPaymentMode(CardUtils$OrcaPaymentPage.getQueryParamsDictforKey(url.search, "componentName")));
  return (handleUserErrorOpt, bodyArr, confirmParam, iframeIdOpt) => {
    let handleUserError = handleUserErrorOpt !== undefined ? handleUserErrorOpt : false;
    let iframeId = iframeIdOpt !== undefined ? iframeIdOpt : keys.iframeId;
    if (typeof paymentMethodList !== "object" || paymentMethodList.TAG !== "Loaded") {
      return;
    } else {
      return completeAuthorizeHandler(keys.clientSecret, bodyArr, confirmParam, iframeId, optLogger, handleUserError, paymentType, keys.sdkHandleOneClickConfirmPayment, undefined, mode, Utils$OrcaPaymentPage.getNonEmptyOption(keys.sdkAuthorization));
    }
  };
}

function useRedsysCompleteAuthorize(optLogger) {
  let completeAuthorizeHandler = useCompleteAuthorizeHandler();
  return (handleUserErrorOpt, bodyArr, confirmParam, iframeIdOpt, clientSecret, headers, sdkAuthorization) => {
    let handleUserError = handleUserErrorOpt !== undefined ? handleUserErrorOpt : false;
    let iframeId = iframeIdOpt !== undefined ? iframeIdOpt : "redsys3ds";
    completeAuthorizeHandler(clientSecret, bodyArr, confirmParam, iframeId, optLogger, handleUserError, "Card", false, headers, undefined, sdkAuthorization);
  };
}

function usePaymentIntent(optLogger, paymentType) {
  let url = RescriptReactRouter.useUrl(undefined, undefined);
  let componentName = CardUtils$OrcaPaymentPage.getQueryParamsDictforKey(url.search, "componentName");
  let paymentTypeFromUrl = CardThemeType$OrcaPaymentPage.getPaymentMode(componentName);
  let blockConfirm = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.isConfirmBlocked);
  let customPodUri = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.customPodUri);
  let paymentMethodList = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.paymentMethodList);
  let keys = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.keys);
  let isCallbackUsedVal = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.isCompleteCallbackUsed);
  let redirectionFlags = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.redirectionFlagsAtom);
  let setIsManualRetryEnabled = Jotai.useSetAtom(JotaiAtoms$OrcaPaymentPage.isManualRetryEnabled);
  return (handleUserErrorOpt, bodyArr, confirmParam, iframeIdOpt, isThirdPartyFlowOpt, intentCallbackOpt, manualRetryOpt, isTrustpayInterceptorConfirmOpt) => {
    let handleUserError = handleUserErrorOpt !== undefined ? handleUserErrorOpt : false;
    let iframeId = iframeIdOpt !== undefined ? iframeIdOpt : keys.iframeId;
    let isThirdPartyFlow = isThirdPartyFlowOpt !== undefined ? isThirdPartyFlowOpt : false;
    let intentCallback = intentCallbackOpt !== undefined ? intentCallbackOpt : param => {};
    let manualRetry = manualRetryOpt !== undefined ? manualRetryOpt : false;
    let isTrustpayInterceptorConfirm = isTrustpayInterceptorConfirmOpt !== undefined ? isTrustpayInterceptorConfirmOpt : false;
    let clientSecret = keys.clientSecret;
    if (clientSecret === undefined) {
      return Utils$OrcaPaymentPage.postFailedSubmitResponse("confirm_payment_failed", "Payment failed. Try again!");
    }
    let paymentIntentId = Utils$OrcaPaymentPage.getPaymentIdOrExtractFromSdkAuth(clientSecret, Utils$OrcaPaymentPage.getNonEmptyOption(keys.sdkAuthorization));
    let baseHeaders = [[
        "X-Client-Source",
        CardThemeType$OrcaPaymentPage.getPaymentModeToStrMapper(paymentTypeFromUrl)
      ]];
    let sdkAuth = Utils$OrcaPaymentPage.getNonEmptyOption(keys.sdkAuthorization);
    if (sdkAuth !== undefined) {
      baseHeaders.push([
        "Authorization",
        sdkAuth
      ]);
    } else {
      baseHeaders.push([
        "api-key",
        confirmParam.publishableKey
      ]);
    }
    let returnUrlArr = [[
        "return_url",
        confirmParam.return_url
      ]];
    let manual_retry = manualRetry ? [[
          "retry_action",
          "manual_retry"
        ]] : [];
    let match = Utils$OrcaPaymentPage.getNonEmptyOption(keys.sdkAuthorization);
    let clientSecretArr = match !== undefined ? [] : [[
          "client_secret",
          clientSecret
        ]];
    let body = clientSecretArr.concat(returnUrlArr, manual_retry);
    let endpoint = ApiEndpoint$OrcaPaymentPage.getApiEndPoint(confirmParam.publishableKey, isThirdPartyFlow);
    let path = `payments/` + paymentIntentId + `/confirm`;
    let uri = endpoint + `/` + path;
    let callIntent = body => {
      let contentLength = body.length.toString();
      let maskedPayload = JSON.stringify(maskPayload(Core__Option.getOr(Utils$OrcaPaymentPage.safeParseOpt(body), null)));
      JSON.stringify(Utils$OrcaPaymentPage.getJsonFromArrayOfJson([
        [
          "payload",
          maskedPayload
        ],
        [
          "headers",
          Utils$OrcaPaymentPage.getJsonFromArrayOfJson(baseHeaders.map(header => [
            header[0],
            header[1]
          ]))
        ]
      ]));
      if (paymentType === "Card") {
        LoggerUtils$OrcaPaymentPage.handleLogging(optLogger, contentLength, "PAYMENT_ATTEMPT", "CARD", undefined);
      } else {
        bodyArr.forEach(param => {
          if (param[0] === "payment_method_type") {
            LoggerUtils$OrcaPaymentPage.handleLogging(optLogger, contentLength, "PAYMENT_ATTEMPT", Utils$OrcaPaymentPage.getStringFromJson(param[1], ""), undefined);
          }
        });
      }
      if (blockConfirm && isIntegrationEnv) {
        console.warn("CONFIRM IS BLOCKED - Body", body);
        console.warn("CONFIRM IS BLOCKED - Headers", JSON.stringify(Object.fromEntries(baseHeaders)));
      } else {
        Core__Promise.$$catch(intentCall(Utils$OrcaPaymentPage.fetchApi, uri, baseHeaders, body, confirmParam, clientSecret, optLogger, handleUserError, paymentType, iframeId, "POST", setIsManualRetryEnabled, customPodUri, keys.sdkHandleOneClickConfirmPayment, 0, undefined, isCallbackUsedVal, componentName, redirectionFlags, Primitive_option.some(Utils$OrcaPaymentPage.getNonEmptyOption(keys.sdkAuthorization)), undefined, isTrustpayInterceptorConfirm).then(val => {
          intentCallback(val);
          return Promise.resolve();
        }), param => Promise.resolve());
      }
    };
    let intentWithoutMandate = mandatePaymentType => callIntent(JSON.stringify(Utils$OrcaPaymentPage.getJsonFromArrayOfJson(body.concat(bodyArr.concat(BrowserSpec$OrcaPaymentPage.broswerInfo()), PaymentBody$OrcaPaymentPage.paymentTypeBody(mandatePaymentType)))));
    if (typeof paymentMethodList !== "object") {
      if (paymentMethodList === "Loading") {
        return Utils$OrcaPaymentPage.postFailedSubmitResponse("payment_methods_loading", "Please wait. Try again!");
      } else {
        return intentWithoutMandate("");
      }
    }
    paymentMethodList.TAG === "Loaded";
    let paymentList = PaymentMethodsRecord$OrcaPaymentPage.itemToObjMapperFromClientList(Utils$OrcaPaymentPage.getDictFromJson(paymentMethodList._0));
    let mandatePaymentType = PaymentMethodsRecord$OrcaPaymentPage.paymentTypeToStringMapper(paymentList.payment_type);
    if (paymentList.payment_methods.length > 0) {
      let match$1 = paymentList.mandate_payment;
      if (match$1 === undefined) {
        return intentWithoutMandate(mandatePaymentType);
      }
      switch (paymentType) {
        case "BankTransfer" :
        case "Samsungpay" :
        case "Paze" :
        case "Other" :
          return intentWithoutMandate(mandatePaymentType);
        default:
          return callIntent(JSON.stringify(Utils$OrcaPaymentPage.getJsonFromArrayOfJson(body.concat(bodyArr.concat(PaymentBody$OrcaPaymentPage.mandateBody(mandatePaymentType), BrowserSpec$OrcaPaymentPage.broswerInfo())))));
      }
    } else {
      Utils$OrcaPaymentPage.postFailedSubmitResponse("payment_methods_empty", "Payment Failed. Try again!");
      console.warn("Please enable atleast one Payment method.");
      return;
    }
  };
}

async function fetchSessions(clientSecret, publishableKey, walletsOpt, isDelayedSessionTokenOpt, logger, customPodUri, endpoint, isPaymentSessionOpt, merchantHostnameOpt, sdkAuthorizationOpt) {
  let wallets = walletsOpt !== undefined ? walletsOpt : [];
  let isDelayedSessionToken = isDelayedSessionTokenOpt !== undefined ? isDelayedSessionTokenOpt : false;
  let isPaymentSession = isPaymentSessionOpt !== undefined ? isPaymentSessionOpt : false;
  let merchantHostname = merchantHostnameOpt !== undefined ? merchantHostnameOpt : Window$OrcaPaymentPage.getRootHostName();
  let sdkAuthorization = sdkAuthorizationOpt !== undefined ? Primitive_option.valFromOption(sdkAuthorizationOpt) : undefined;
  let headers = Object.fromEntries([[
      "X-Merchant-Domain",
      merchantHostname
    ]]);
  let paymentIntentId = Utils$OrcaPaymentPage.getPaymentIdOrExtractFromSdkAuth(clientSecret, Utils$OrcaPaymentPage.getNonEmptyOption(sdkAuthorization));
  let bodyArr = [
    [
      "payment_id",
      paymentIntentId
    ],
    [
      "wallets",
      wallets
    ],
    [
      "delayed_session_token",
      isDelayedSessionToken
    ]
  ];
  let match = Utils$OrcaPaymentPage.getNonEmptyOption(sdkAuthorization);
  let body = match !== undefined ? Utils$OrcaPaymentPage.getJsonFromArrayOfJson(bodyArr) : Utils$OrcaPaymentPage.getJsonFromArrayOfJson(bodyArr.concat([[
        "client_secret",
        clientSecret
      ]]));
  let uri = APIUtils$OrcaPaymentPage.generateApiUrlV1({
    publishableKey: undefined,
    customBackendBaseUrl: endpoint,
    clientSecret: undefined,
    forceSync: undefined,
    pollId: undefined,
    payoutId: undefined,
    sdkAuthorization: sdkAuthorization
  }, "FetchSessions");
  let onSuccess = data => data;
  let onFailure = param => null;
  return await Utils$OrcaPaymentPage.fetchApiWithLogging(uri, "SESSIONS_CALL", logger, onSuccess, onFailure, JSON.stringify(body), headers, "POST", Primitive_option.some(customPodUri), Primitive_option.some(publishableKey), isPaymentSession, undefined, Primitive_option.some(sdkAuthorization), undefined);
}

async function confirmPayout(clientSecret, publishableKey, logger, customPodUri, endpoint, body, payoutId) {
  let uri = APIUtils$OrcaPaymentPage.generateApiUrlV1({
    publishableKey: publishableKey,
    customBackendBaseUrl: endpoint,
    clientSecret: clientSecret,
    forceSync: undefined,
    pollId: undefined,
    payoutId: payoutId,
    sdkAuthorization: undefined
  }, "ConfirmPayout");
  let onSuccess = data => data;
  let onFailure = param => null;
  let body$1 = Utils$OrcaPaymentPage.getJsonFromArrayOfJson(body.concat([[
      "client_secret",
      clientSecret
    ]]));
  return await Utils$OrcaPaymentPage.fetchApiWithLogging(uri, "CONFIRM_PAYOUT_CALL", logger, onSuccess, onFailure, JSON.stringify(body$1), undefined, "POST", Primitive_option.some(customPodUri), Primitive_option.some(publishableKey), undefined, undefined, undefined, undefined);
}

async function createPaymentMethod(clientSecret, publishableKey, logger, customPodUri, endpoint, body) {
  let uri = APIUtils$OrcaPaymentPage.generateApiUrlV1({
    publishableKey: publishableKey,
    customBackendBaseUrl: endpoint,
    clientSecret: clientSecret,
    forceSync: undefined,
    pollId: undefined,
    payoutId: undefined,
    sdkAuthorization: undefined
  }, "CreatePaymentMethod");
  let onSuccess = data => data;
  let onFailure = param => null;
  let body$1 = Utils$OrcaPaymentPage.getJsonFromArrayOfJson(body.concat([[
      "client_secret",
      clientSecret
    ]]));
  return await Utils$OrcaPaymentPage.fetchApiWithLogging(uri, "CREATE_CUSTOMER_PAYMENT_METHODS_CALL", logger, onSuccess, onFailure, JSON.stringify(body$1), undefined, "POST", Primitive_option.some(customPodUri), Primitive_option.some(publishableKey), undefined, undefined, undefined, undefined);
}

async function fetchClientList(clientSecret, publishableKey, logger, customPodUri, endpoint, isPaymentSessionOpt, sdkAuthorizationOpt) {
  let isPaymentSession = isPaymentSessionOpt !== undefined ? isPaymentSessionOpt : false;
  let sdkAuthorization = sdkAuthorizationOpt !== undefined ? Primitive_option.valFromOption(sdkAuthorizationOpt) : undefined;
  let uri = APIUtils$OrcaPaymentPage.generateApiUrlV1({
    publishableKey: publishableKey,
    customBackendBaseUrl: endpoint,
    clientSecret: clientSecret,
    forceSync: undefined,
    pollId: undefined,
    payoutId: undefined,
    sdkAuthorization: sdkAuthorization
  }, "FetchClientList");
  let onSuccess = data => data;
  let onFailure = param => null;
  return await Utils$OrcaPaymentPage.fetchApiWithLogging(uri, "CLIENT_LIST_CALL", logger, onSuccess, onFailure, undefined, undefined, "GET", Primitive_option.some(customPodUri), Primitive_option.some(publishableKey), isPaymentSession, undefined, Primitive_option.some(sdkAuthorization), undefined);
}

function paymentIntentForPaymentSession(body, paymentType, payload, publishableKey, clientSecret, logger, customPodUri, redirectionFlags, isPaymentSessionOpt, sdkAuthorizationOpt, modeOpt) {
  let isPaymentSession = isPaymentSessionOpt !== undefined ? isPaymentSessionOpt : true;
  let sdkAuthorization = sdkAuthorizationOpt !== undefined ? Primitive_option.valFromOption(sdkAuthorizationOpt) : undefined;
  let mode = modeOpt !== undefined ? modeOpt : "NONE";
  let confirmParams = Utils$OrcaPaymentPage.getDictFromDict(Utils$OrcaPaymentPage.getDictFromJson(payload), "confirmParams");
  let redirect = Utils$OrcaPaymentPage.getString(confirmParams, "redirect", "if_required");
  let returnUrl = Utils$OrcaPaymentPage.getString(confirmParams, "return_url", "");
  let confirmParam_redirect = redirect;
  let confirmParam = {
    return_url: returnUrl,
    publishableKey: publishableKey,
    redirect: confirmParam_redirect
  };
  let paymentIntentId = Utils$OrcaPaymentPage.getPaymentIdOrExtractFromSdkAuth(clientSecret, Utils$OrcaPaymentPage.getNonEmptyOption(sdkAuthorization));
  let endpoint = ApiEndpoint$OrcaPaymentPage.getApiEndPoint(publishableKey, true);
  let uri = endpoint + `/payments/` + paymentIntentId + `/confirm`;
  let sdkAuth = Utils$OrcaPaymentPage.getNonEmptyOption(sdkAuthorization);
  let headers = sdkAuth !== undefined ? [[
        "Authorization",
        sdkAuth
      ]] : [[
        "api-key",
        publishableKey
      ]];
  let broswerInfo = BrowserSpec$OrcaPaymentPage.broswerInfo();
  let returnUrlArr = [[
      "return_url",
      returnUrl
    ]];
  let match = Utils$OrcaPaymentPage.getNonEmptyOption(sdkAuthorization);
  let clientSecretArr = match !== undefined ? [] : [[
        "client_secret",
        clientSecret
      ]];
  let bodyStr = JSON.stringify(Utils$OrcaPaymentPage.getJsonFromArrayOfJson(body.concat(broswerInfo, clientSecretArr, returnUrlArr)));
  return intentCall(Utils$OrcaPaymentPage.fetchApi, uri, headers, bodyStr, confirmParam, clientSecret, logger, false, paymentType, "", "POST", param => {}, customPodUri, false, 0, isPaymentSession, undefined, undefined, redirectionFlags, Primitive_option.some(sdkAuthorization), mode, undefined);
}

async function callAuthLink(publishableKey, clientSecret, paymentMethodType, pmAuthConnectorsArr, iframeId, logger, sdkAuthorizationOpt) {
  let sdkAuthorization = sdkAuthorizationOpt !== undefined ? Primitive_option.valFromOption(sdkAuthorizationOpt) : undefined;
  let uri = APIUtils$OrcaPaymentPage.generateApiUrlV1({
    publishableKey: publishableKey,
    customBackendBaseUrl: undefined,
    clientSecret: undefined,
    forceSync: undefined,
    pollId: undefined,
    payoutId: undefined,
    sdkAuthorization: sdkAuthorization
  }, "CallAuthLink");
  let bodyArr = [
    [
      "payment_id",
      Utils$OrcaPaymentPage.getPaymentIdOrExtractFromSdkAuth(Core__Option.getOr(clientSecret, ""), Utils$OrcaPaymentPage.getNonEmptyOption(sdkAuthorization))
    ],
    [
      "payment_method",
      "bank_debit"
    ],
    [
      "payment_method_type",
      paymentMethodType
    ]
  ];
  let match = Utils$OrcaPaymentPage.getNonEmptyOption(sdkAuthorization);
  let body = match !== undefined ? Utils$OrcaPaymentPage.getJsonFromArrayOfJson(bodyArr) : Utils$OrcaPaymentPage.getJsonFromArrayOfJson(bodyArr.concat([[
        "client_secret",
        Core__Option.getOr(clientSecret, "")
      ]]));
  let onSuccess = data => {
    let metaData = Utils$OrcaPaymentPage.getJsonFromArrayOfJson([
      [
        "linkToken",
        Utils$OrcaPaymentPage.getString(Utils$OrcaPaymentPage.getDictFromJson(data), "link_token", "")
      ],
      [
        "pmAuthConnectorArray",
        pmAuthConnectorsArr
      ],
      [
        "publishableKey",
        publishableKey
      ],
      [
        "sdkAuthorization",
        Core__Option.getOr(sdkAuthorization, "")
      ],
      [
        "clientSecret",
        Core__Option.getOr(clientSecret, "")
      ],
      [
        "isForceSync",
        false
      ]
    ]);
    Utils$OrcaPaymentPage.messageParentWindow(undefined, [
      [
        "fullscreen",
        true
      ],
      [
        "param",
        "plaidSDK"
      ],
      [
        "iframeId",
        iframeId
      ],
      [
        "metadata",
        metaData
      ]
    ]);
    return null;
  };
  let onFailure = param => null;
  return await Utils$OrcaPaymentPage.fetchApiWithLogging(uri, "PAYMENT_METHODS_AUTH_LINK_CALL", logger, onSuccess, onFailure, JSON.stringify(body), undefined, "POST", undefined, Primitive_option.some(publishableKey), undefined, undefined, Primitive_option.some(sdkAuthorization), undefined);
}

async function callAuthExchange(publicToken, clientSecret, paymentMethodType, publishableKey, setOptionValue, logger, sdkAuthorizationOpt) {
  let sdkAuthorization = sdkAuthorizationOpt !== undefined ? Primitive_option.valFromOption(sdkAuthorizationOpt) : undefined;
  let uri = APIUtils$OrcaPaymentPage.generateApiUrlV1({
    publishableKey: publishableKey,
    customBackendBaseUrl: undefined,
    clientSecret: undefined,
    forceSync: undefined,
    pollId: undefined,
    payoutId: undefined,
    sdkAuthorization: sdkAuthorization
  }, "CallAuthExchange");
  let paymentIntentId = Utils$OrcaPaymentPage.getPaymentIdOrExtractFromSdkAuth(Core__Option.getOr(clientSecret, ""), Utils$OrcaPaymentPage.getNonEmptyOption(sdkAuthorization));
  let bodyArr = [
    [
      "payment_id",
      paymentIntentId
    ],
    [
      "payment_method",
      "bank_debit"
    ],
    [
      "payment_method_type",
      paymentMethodType
    ],
    [
      "public_token",
      publicToken
    ]
  ];
  let match = Utils$OrcaPaymentPage.getNonEmptyOption(sdkAuthorization);
  let body = match !== undefined ? Utils$OrcaPaymentPage.getJsonFromArrayOfJson(bodyArr) : Utils$OrcaPaymentPage.getJsonFromArrayOfJson(bodyArr.concat([[
        "client_secret",
        Core__Option.getOr(clientSecret, "")
      ]]));
  let onSuccess = param => {
    let endpoint = ApiEndpoint$OrcaPaymentPage.getApiEndPoint(undefined, undefined);
    Core__Promise.$$catch(fetchClientList(Core__Option.getOr(clientSecret, ""), publishableKey, logger, "", endpoint, undefined, Primitive_option.some(sdkAuthorization)).then(clientListResponse => {
      let clientListResponse$1 = Object.fromEntries([[
          "clientList",
          clientListResponse
        ]]);
      setOptionValue(prev => {
        let newrecord = {...prev};
        newrecord.customerPaymentMethods = PaymentType$OrcaPaymentPage.createCustomerObjArrFromClientList(clientListResponse$1, "clientList");
        return newrecord;
      });
      return Promise.resolve(null);
    }), e => {
      console.error("Unable to retrieve customer/payment_methods after auth/exchange because of ", e);
      return Promise.resolve(null);
    });
    return null;
  };
  let onFailure = param => null;
  return await Utils$OrcaPaymentPage.fetchApiWithLogging(uri, "PAYMENT_METHODS_AUTH_EXCHANGE_CALL", logger, onSuccess, onFailure, JSON.stringify(body), undefined, "POST", undefined, Primitive_option.some(publishableKey), undefined, undefined, Primitive_option.some(sdkAuthorization), undefined);
}

async function calculateTax(apiKey, clientSecret, paymentMethodType, shippingAddress, logger, customPodUri, sessionId, sdkAuthorization) {
  let uri = APIUtils$OrcaPaymentPage.generateApiUrlV1({
    publishableKey: apiKey,
    customBackendBaseUrl: undefined,
    clientSecret: clientSecret,
    forceSync: undefined,
    pollId: undefined,
    payoutId: undefined,
    sdkAuthorization: sdkAuthorization
  }, "CalculateTax");
  let onSuccess = data => data;
  let onFailure = param => null;
  let body = [
    [
      "shipping",
      shippingAddress
    ],
    [
      "payment_method_type",
      paymentMethodType
    ]
  ];
  let match = Utils$OrcaPaymentPage.getNonEmptyOption(sdkAuthorization);
  if (match !== undefined) {
    
  } else {
    body.push([
      "client_secret",
      clientSecret
    ]);
  }
  Core__Option.mapOr(sessionId, undefined, id => {
    body.push([
      "session_id",
      id
    ]);
  });
  return await Utils$OrcaPaymentPage.fetchApiWithLogging(uri, "EXTERNAL_TAX_CALCULATION", logger, onSuccess, onFailure, JSON.stringify(Utils$OrcaPaymentPage.getJsonFromArrayOfJson(body)), undefined, "POST", Primitive_option.some(customPodUri), Primitive_option.some(apiKey), undefined, undefined, Primitive_option.some(sdkAuthorization), undefined);
}

function usePostSessionTokens(optLogger, paymentType, paymentMethod) {
  let url = RescriptReactRouter.useUrl(undefined, undefined);
  let paymentTypeFromUrl = CardThemeType$OrcaPaymentPage.getPaymentMode(CardUtils$OrcaPaymentPage.getQueryParamsDictforKey(url.search, "componentName"));
  let customPodUri = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.customPodUri);
  let paymentMethodList = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.paymentMethodList);
  let keys = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.keys);
  let redirectionFlags = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.redirectionFlagsAtom);
  let setIsManualRetryEnabled = Jotai.useSetAtom(JotaiAtoms$OrcaPaymentPage.isManualRetryEnabled);
  return (handleUserErrorOpt, bodyArr, confirmParam, iframeIdOpt, isThirdPartyFlowOpt, intentCallbackOpt, $staropt$star, $staropt$star$1) => {
    let handleUserError = handleUserErrorOpt !== undefined ? handleUserErrorOpt : false;
    let iframeId = iframeIdOpt !== undefined ? iframeIdOpt : keys.iframeId;
    let isThirdPartyFlow = isThirdPartyFlowOpt !== undefined ? isThirdPartyFlowOpt : false;
    let intentCallback = intentCallbackOpt !== undefined ? intentCallbackOpt : param => {};
    if ($staropt$star === undefined) {
      false;
    }
    if ($staropt$star$1 === undefined) {
      false;
    }
    let clientSecret = keys.clientSecret;
    if (clientSecret === undefined) {
      return Utils$OrcaPaymentPage.postFailedSubmitResponse("post_session_tokens_failed", "Post Session Tokens failed. Try again!");
    }
    let paymentIntentId = Utils$OrcaPaymentPage.getPaymentIdOrExtractFromSdkAuth(clientSecret, Utils$OrcaPaymentPage.getNonEmptyOption(keys.sdkAuthorization));
    let headers = [
      [
        "Content-Type",
        "application/json"
      ],
      [
        "X-Client-Source",
        CardThemeType$OrcaPaymentPage.getPaymentModeToStrMapper(paymentTypeFromUrl)
      ]
    ];
    let body = [
      [
        "payment_id",
        paymentIntentId
      ],
      [
        "payment_method_type",
        paymentType
      ],
      [
        "payment_method",
        paymentMethod
      ]
    ];
    let sdkAuth = Utils$OrcaPaymentPage.getNonEmptyOption(keys.sdkAuthorization);
    if (sdkAuth !== undefined) {
      headers.push([
        "Authorization",
        sdkAuth
      ]);
    } else {
      headers.push([
        "api-key",
        confirmParam.publishableKey
      ]);
      body.push([
        "client_secret",
        clientSecret
      ]);
    }
    let endpoint = ApiEndpoint$OrcaPaymentPage.getApiEndPoint(confirmParam.publishableKey, isThirdPartyFlow);
    let uri = endpoint + `/payments/` + paymentIntentId + `/post_session_tokens`;
    let callIntent = body => {
      let contentLength = body.length.toString();
      let maskedPayload = JSON.stringify(maskPayload(Core__Option.getOr(Utils$OrcaPaymentPage.safeParseOpt(body), null)));
      JSON.stringify(Utils$OrcaPaymentPage.getJsonFromArrayOfJson([
        [
          "payload",
          maskedPayload
        ],
        [
          "headers",
          Utils$OrcaPaymentPage.getJsonFromArrayOfJson(headers.map(header => [
            header[0],
            header[1]
          ]))
        ]
      ]));
      if (paymentType === "Card") {
        LoggerUtils$OrcaPaymentPage.handleLogging(optLogger, contentLength, "PAYMENT_ATTEMPT", "CARD", undefined);
      } else {
        bodyArr.forEach(param => {
          if (param[0] === "payment_method_type") {
            LoggerUtils$OrcaPaymentPage.handleLogging(optLogger, contentLength, "PAYMENT_ATTEMPT", Utils$OrcaPaymentPage.getStringFromJson(param[1], ""), undefined);
          }
        });
      }
      Core__Promise.$$catch(intentCall(Utils$OrcaPaymentPage.fetchApi, uri, headers, body, confirmParam, clientSecret, optLogger, handleUserError, paymentType, iframeId, "POST", setIsManualRetryEnabled, customPodUri, keys.sdkHandleOneClickConfirmPayment, 0, undefined, undefined, undefined, redirectionFlags, Primitive_option.some(keys.sdkAuthorization), undefined, undefined).then(val => {
        intentCallback(val);
        return Promise.resolve();
      }), param => Promise.resolve());
    };
    let intentWithoutMandate = mandatePaymentType => callIntent(JSON.stringify(Utils$OrcaPaymentPage.getJsonFromArrayOfJson(body.concat(bodyArr.concat(BrowserSpec$OrcaPaymentPage.broswerInfo()), PaymentBody$OrcaPaymentPage.paymentTypeBody(mandatePaymentType)))));
    if (typeof paymentMethodList !== "object") {
      if (paymentMethodList === "Loading") {
        return Utils$OrcaPaymentPage.postFailedSubmitResponse("payment_methods_loading", "Please wait. Try again!");
      } else {
        return intentWithoutMandate("");
      }
    }
    paymentMethodList.TAG === "Loaded";
    let paymentList = PaymentMethodsRecord$OrcaPaymentPage.itemToObjMapperFromClientList(Utils$OrcaPaymentPage.getDictFromJson(paymentMethodList._0));
    let mandatePaymentType = PaymentMethodsRecord$OrcaPaymentPage.paymentTypeToStringMapper(paymentList.payment_type);
    if (paymentList.payment_methods.length > 0) {
      let match = paymentList.mandate_payment;
      if (match === undefined) {
        return intentWithoutMandate(mandatePaymentType);
      }
      switch (paymentType) {
        case "BankTransfer" :
        case "Samsungpay" :
        case "Paze" :
        case "Other" :
          return intentWithoutMandate(mandatePaymentType);
        default:
          return callIntent(JSON.stringify(Utils$OrcaPaymentPage.getJsonFromArrayOfJson(body.concat(bodyArr.concat(PaymentBody$OrcaPaymentPage.mandateBody(mandatePaymentType), BrowserSpec$OrcaPaymentPage.broswerInfo())))));
      }
    } else {
      Utils$OrcaPaymentPage.postFailedSubmitResponse("payment_methods_empty", "Payment Failed. Try again!");
      console.warn("Please enable atleast one Payment method.");
      return;
    }
  };
}

async function fetchEnabledAuthnMethodsToken(clientSecret, publishableKey, logger, customPodUri, endpoint, isPaymentSessionOpt, profileId, authenticationId) {
  let isPaymentSession = isPaymentSessionOpt !== undefined ? isPaymentSessionOpt : false;
  let uri = APIUtils$OrcaPaymentPage.generateApiUrlV1({
    publishableKey: undefined,
    customBackendBaseUrl: endpoint,
    clientSecret: undefined,
    forceSync: undefined,
    pollId: undefined,
    payoutId: undefined,
    sdkAuthorization: undefined,
    authenticationId: authenticationId
  }, "FetchEnabledAuthnMethodsToken");
  let body = Utils$OrcaPaymentPage.getJsonFromArrayOfJson([[
      "client_secret",
      clientSecret
    ]]);
  let headers = Object.fromEntries([[
      "x-profile-id",
      profileId
    ]]);
  let onSuccess = data => data;
  let onFailure = param => null;
  return await Utils$OrcaPaymentPage.fetchApiWithLogging(uri, "ENABLED_AUTHN_METHODS_TOKEN_CALL", logger, onSuccess, onFailure, JSON.stringify(body), headers, "POST", Primitive_option.some(customPodUri), Primitive_option.some(publishableKey), isPaymentSession, undefined, undefined, undefined);
}

async function fetchEligibilityCheck(clientSecret, publishableKey, logger, customPodUri, endpoint, isPaymentSessionOpt, profileId, authenticationId, bodyArr) {
  let isPaymentSession = isPaymentSessionOpt !== undefined ? isPaymentSessionOpt : false;
  let uri = APIUtils$OrcaPaymentPage.generateApiUrlV1({
    publishableKey: undefined,
    customBackendBaseUrl: endpoint,
    clientSecret: undefined,
    forceSync: undefined,
    pollId: undefined,
    payoutId: undefined,
    sdkAuthorization: undefined,
    authenticationId: authenticationId
  }, "FetchEligibilityCheck");
  let body = Utils$OrcaPaymentPage.getJsonFromArrayOfJson(bodyArr.concat([[
      "client_secret",
      clientSecret
    ]]));
  let headers = Object.fromEntries([[
      "x-profile-id",
      profileId
    ]]);
  let onSuccess = data => data;
  let onFailure = param => null;
  return await Utils$OrcaPaymentPage.fetchApiWithLogging(uri, "ELIGIBILITY_CHECK_CALL", logger, onSuccess, onFailure, JSON.stringify(body), headers, "POST", Primitive_option.some(customPodUri), Primitive_option.some(publishableKey), isPaymentSession, undefined, undefined, undefined);
}

async function fetchAuthenticationSync(clientSecret, publishableKey, logger, customPodUri, endpoint, isPaymentSessionOpt, profileId, authenticationId, merchantId, bodyArr) {
  let isPaymentSession = isPaymentSessionOpt !== undefined ? isPaymentSessionOpt : false;
  let uri = APIUtils$OrcaPaymentPage.generateApiUrlV1({
    publishableKey: undefined,
    customBackendBaseUrl: endpoint,
    clientSecret: undefined,
    forceSync: undefined,
    pollId: undefined,
    payoutId: undefined,
    sdkAuthorization: undefined,
    authenticationId: authenticationId,
    merchantId: merchantId
  }, "FetchAuthenticationSync");
  let body = Utils$OrcaPaymentPage.getJsonFromArrayOfJson(bodyArr.concat([[
      "client_secret",
      clientSecret
    ]]));
  let headers = Object.fromEntries([[
      "x-profile-id",
      profileId
    ]]);
  let onSuccess = data => data;
  let onFailure = err => err;
  return await Utils$OrcaPaymentPage.fetchApiWithLogging(uri, "AUTHENTICATION_SYNC_CALL", logger, onSuccess, onFailure, JSON.stringify(body), headers, "POST", Primitive_option.some(customPodUri), Primitive_option.some(publishableKey), isPaymentSession, undefined, undefined, undefined);
}

function getConstructedPaymentMethodName(paymentMethod, paymentMethodType) {
  switch (paymentMethod) {
    case "bank_debit" :
      return paymentMethodType + "_debit";
    case "bank_transfer" :
      if (Constants$OrcaPaymentPage.bankTransferList.includes(paymentMethodType)) {
        return paymentMethodType;
      } else {
        return paymentMethodType + "_transfer";
      }
    case "card" :
      return "card";
    default:
      return paymentMethodType;
  }
}

async function fetchSdkConfigs(clientSecret, publishableKey, logger, customPodUri, endpoint, sdkAuthorizationOpt) {
  let sdkAuthorization = sdkAuthorizationOpt !== undefined ? Primitive_option.valFromOption(sdkAuthorizationOpt) : undefined;
  let uri = APIUtils$OrcaPaymentPage.generateApiUrlV1({
    publishableKey: publishableKey,
    customBackendBaseUrl: endpoint,
    clientSecret: clientSecret,
    forceSync: undefined,
    pollId: undefined,
    payoutId: undefined,
    sdkAuthorization: sdkAuthorization
  }, "FetchSdkConfigs");
  let onSuccess = data => data;
  let onFailure = param => null;
  return await Utils$OrcaPaymentPage.fetchApiWithLogging(uri, "SDK_CONFIGS_CALL", logger, onSuccess, onFailure, undefined, undefined, "GET", Primitive_option.some(customPodUri), Primitive_option.some(publishableKey), undefined, undefined, Primitive_option.some(sdkAuthorization), undefined);
}

export {
  getPaymentType,
  retrievePaymentIntent,
  fetchPaymentMethodEligibility,
  threeDsAuth,
  pollRetrievePaymentIntent,
  retrieveStatus,
  pollStatus,
  intentCall,
  usePaymentSync,
  maskStr,
  maskPayload,
  useCompleteAuthorizeHandler,
  useCompleteAuthorize,
  useRedsysCompleteAuthorize,
  usePaymentIntent,
  fetchSessions,
  confirmPayout,
  createPaymentMethod,
  fetchClientList,
  paymentIntentForPaymentSession,
  callAuthLink,
  callAuthExchange,
  calculateTax,
  usePostSessionTokens,
  fetchEnabledAuthnMethodsToken,
  fetchEligibilityCheck,
  fetchAuthenticationSync,
  getConstructedPaymentMethodName,
  fetchSdkConfigs,
}
/* jotai Not a pure module */
